export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setProduct(state, product) {
    if (product) {
      state.product = {
        ...product,
        pixel: product && product.pixel ? product.pixel : []
      };
    } else {
      state.product = null;
    }
  },
  setNewProduct(state, new_product) {
    state.newProduct = new_product;
  },
  setProducts(state, products) {
    state.products = products;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCurrencies(state, currencies) {
    state.currencies = currencies;
  },
  setPaymentMethods(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
  setCoupons(state, coupons) {
    state.coupons = coupons;
  },
  setCoupon(state, coupon) {
    state.coupon = coupon;
  },
  setGatewayProviders(state, providers) {
    state.gatewayProviders = providers;
  },
  setProductFilters(state, filters) {
    state.productFilters = filters;
  },
  setFilterDates(state, dates) {
    state.filterDates = dates;

    state.salesFilters = {
      ...state.salesFilters,
      created_at_after: dates?.[0] || "",
      created_at_before: dates?.[1] || ""
    };
  }
};
